import {
    AchievementsIcon,
    ActivitynIcon,
    BillingHistoryIcon,
    CalendarbIcon,
    InformationIcon,
    InsightsnIcon,
    InvoicesIcon,
    JobSitesIcon,
    MapIcon,
    MembersIcon,
    OrganizationIcon,
    OvertimeIcon,
    PaymentsnIcon,
    PermissionIcon,
    ProjectsIcon,
    SecurityLoginIcon,
    TimeOffIcon,
    TimerTrackingIcon,
    TimesheetIcon,
    WorkBreaksnIcon
} from '../../../icons';
export const settingsData = [
    {
        title: 'General',
        items: [
            {
                icon: <OrganizationIcon fontSize="large" />,
                title: 'Organization',
                description: 'Update your business name, location, time zone, and additional information.',
                link: '/general',
            },
            {
                icon: <ProjectsIcon fontSize="large" />,
                title: 'Projects',
                description: 'Configure default team members for new projects',
                link: '/general',
            },
            {
                icon: <TimerTrackingIcon fontSize="large" />,
                title: 'Timer & Tracking',
                description: 'Manage how your team tracks time on both the desktop and the new corporate application.',
                link: '/general',
            },
            {
                icon: <SecurityLoginIcon fontSize="large" />,
                title: 'Security & Login',
                description: 'Set up two-step verification and single sign-on options for enhanced security.',
                link: '/general',
            },
            {
                icon: <MembersIcon fontSize="large" />,
                title: 'Members',
                description: 'Modify custom fields and update email alerts for user accounts.',
                link: '/general',
            },
            {
                icon: <PermissionIcon fontSize="large" />,
                title: 'Permission',
                description: 'Set up access rights for your team members in your organization.',
                link: '/general',
            },
        ],
    },
    {
        title: 'Features',
        items: [
            {
                icon: <ActivitynIcon fontSize="large" />,
                title: 'Activity',
                description: 'Monitor screenshots, keyboard and mouse actions, applications, URLs, and more.',
                link: '/feature',
            },
            {
                icon: <InsightsnIcon fontSize="large" />,
                title: 'Insights',
                description: 'Evaluate how productive the apps and websites are for your team members.',
                link: '/feature',
            },
            {
                icon: <TimesheetIcon fontSize="large" />,
                title: 'Timesheets',
                description: 'Enable team members to adjust their time entries, with or without providing a reason.',
                link: '/feature',
            },

            {
                icon: <InvoicesIcon fontSize="large" />,
                title: 'Invoices',
                description: 'Configure invoices including your tax ID, payment terms, and a button for payments.',
                link: '/feature',
            },
            {
                icon: <CalendarbIcon fontSize="large" />,
                title: 'Calendar',
                description: 'Control the visibility of team member calendars, and set alerts for shifts and grace periods.',
                link: '/feature',
            },
            {
                icon: <TimeOffIcon fontSize="large" />,
                title: 'Time off',
                description: "Oversee your organization's leave and holiday regulations.",
                link: '/feature',
            },
            {
                icon: <MapIcon fontSize="large" />,
                title: 'Map',
                description: 'Manage the activation of location tracking within the mobile application.',
                link: '/feature',
            },
            {
                icon: <JobSitesIcon fontSize="large" />,
                title: 'Job sites',
                description: 'Limit time tracking to designated job locations.',
                link: '/feature',
            },
            {
                icon: <PaymentsnIcon fontSize="large" />,
                title: 'Payments',
                description: 'Configure both manual payments and automated payroll systems.',
                link: '/feature',
            },
            {
                icon: <AchievementsIcon fontSize="large" />,
                title: 'Achievements',
                description: 'Recognize your team members with badges when they achieve their targets.',
                link: '/feature',
            },
            {
                icon: <WorkBreaksnIcon fontSize="large" />,
                title: 'Work breaks',
                description: "Oversee your team's break times effectively.",
                link: '/feature',
            },
            {
                icon: <OvertimeIcon fontSize="large" />,
                title: 'Overtime',
                description: 'Establish weekly overtime guidelines for your team members.',
                link: '/feature',
            },
        ],
    },
    {
        title: 'Billing',
        items: [
            {
                icon: <InformationIcon fontSize="large" />,
                title: 'Information',
                description: 'Check your current plan and billing details.',
                link: '/billing',
            },
            {
                icon: <BillingHistoryIcon fontSize="large" />,
                title: 'Billing history',
                description: 'Review your billing history and download previous invoices.',
                link: '/billing',
            },
        ],
    },
];
